<template>
    <div id="test">
      <ul class="model">
        <li v-for="item in title" v-html="item.enName"></li>
      </ul>
      <ul class="spec">
        <li v-for="(item,index) in list">
          <template v-for="levelone in item.specLevelOnes">
            <div class="categary">
              <p :class="index!=0?'hidden':''">
                {{levelone.cnName}}
              </p>
            </div>
            <template v-for="leveltwo in levelone.specleveltwos">
              <div :class="[index!=0?'hidden':'','title']" v-html="leveltwo.cnName"></div>
              <div class="info" v-html="leveltwo.value"></div>
            </template>
          </template>
        </li>
      </ul>
    </div>
</template>
<style scoped lang="less">
  @borderline: #9f9f9f;
  .hidden {
    visibility: hidden;
  }
  .model {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      width: 50%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #c0c1c2;
      border-left: 1px solid #c0c1c2;
      text-align: center;
      &:nth-of-type(1) {
        background-color: #f4f5f6;
        border-left: none;
      }
      &:nth-of-type(2) {
        background-color: #e7e8ea;
      }
      &:nth-of-type(3) {
        background-color: #d3d4d5;
      }
    }
  }
  .spec {
    width: 100%;
    align-items: center;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    li {
      width: 50%;
      height: 100%;
      text-align: center;
      &:nth-of-type(1) {
        .info {
          background-color: #f4f5f6;
          border-left: none;
        }
      }
      &:nth-of-type(2) {
        .info {
          background-color: #e7e8ea;
        }
      }
      &:nth-of-type(3) {
        .info {
          background-color: #d3d4d5;
        }
      }
    }
  }
  .categary {
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #d3d4d5;
    font-size: 14px;
    margin-top: 12px;
  }
  .title {
    font-size: 12px;
    line-height: 33px;
    text-align: left;
    padding-left: 6px;
  }
  .info {
    font-size: 12px;
    min-height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #c0c1c2;
    border-bottom: 1px solid #c0c1c2;
    border-left: 1px solid #c0c1c2;
  }
</style>
<script>
    export default{
        data(){
            return{
                api: this.$store.state.api,
                title: [],
                list: [],
                sku8Ds: this.$route.query.sku8Ds
            }
        },
        components:{

        },
        created() {
          this.getResult();
        },

        methods: {
          getResult() {
            let url = this.api.product.findDetailSpecCompare();
            this.$http.get(url,{
              params: {
                  sku8Ds: this.sku8Ds
              }
            })
            .then(res=>{
              if(res.data.result&&res.data.code=='00'){
                this.list = res.data.returnData.OutSpecCompare.OutSkuDetailSpec;
                this.title = res.data.returnData.OutSpecCompare.outMasterData;
              }
            })
            .catch(res2=>{
              let res = {"result":true,"code":"00","returnData":{"OutSpecCompare":{"outMasterData":[{"sku8D":"P13066305","cnName":"HT-ST5000系列 7.1.2声道环绕家庭影音系统","enName":"HT-ST5000","skuStatus":"status01","color":"黑","colorImage":"/content/dam/sonystyle/products/color/black/color_icon_black_30x30.gif","imagePath":"/content/dam/sonystyle/products/home_theater/ht_st5000/product/img_ht_st5000_b_0.jpg","listingDate":"2017-12-1","promoteStatus":"","otherStatus":"","categoryCnName":"BRAVIA家庭影音系统","categoryEnName":"Home Theater","seriesCnName":"","seriesEnName":"Home Theater","productModelCnName":"","productModelEnName":"ST5000","filterLevelOneRefs":[]},{"sku8D":"P50000216","cnName":"FDR-X3000R 4K高清酷拍运动相机/迷你摄像机 旅游手持套装（4K光学防抖 60米防水壳 3倍变焦）","enName":"FDR-X3000R 旅游手持套装","skuStatus":"status01","color":"白","colorImage":"/content/dam/sonystyle/products/color/white/color_icon_white_30x30.gif","imagePath":"/content/dam/sonystyle/products/action-cam/fdr_x3000r/product/img_fdr_x3000r_stg1_1.jpg","listingDate":"2017-12-1","promoteStatus":"","otherStatus":"","categoryCnName":"运动相机","categoryEnName":"Action Cam","seriesCnName":"","seriesEnName":"4K","productModelCnName":"运动相机FDR-X3000","productModelEnName":"FDR-X3000","filterLevelOneRefs":[]}],"outSkuSpec":[null,null]}}};
              if(res.result&&res.code=='00'){
                this.list = res.returnData.OutSpecCompare.OutSkuDetailSpec;

              }
            })
          }

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/CompareResult.vue